import { IUserDisplayData } from '@gem/models/userModel';

import { WsRequest } from 'APP/wsApi/wsAppApi/requests/request.types';
import { SearchMessagesRequest } from 'APP/wsApi/wsAppApi/types/message/message_requests_pb';

import { IGroup } from '../group/groupModel.types';
import { IMessage } from '../message/messageModel.types';
import { ISpace } from '../space/spaceModel.types';

export interface IGlobalSearchOptions {
  query: string;
  offset: number;
  limit: number;
  cursor?: string;
}

export interface IGlobalSearch {
  groups: IGroup[];
  hasMoreResults: boolean;
  users: IUserDisplayData[];
  spaces: ISpace[];
  cursor?: string;
}

export interface ISearchUsersInSpaceRequest {
  spaceId: string;
  searchQuery: string;
  cursor?: string;
  limit?: number;
}

export interface ISearchUsersInGroupRequest {
  role?: GroupUserRoleRequestEnum;
  cursor?: string;
  limit?: number;
  groupId: string;
  searchQuery: string;
}

export enum GroupUserRoleRequestEnum {
  Owner = 'OWNER',
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Guest = 'GUEST',
}

export interface ISearchMessagesRequest extends Omit<WsRequest<SearchMessagesRequest>, 'chatId'> {
  groupId: string;
}

export interface ISearchMessagesResponse {
  results: ISearchMessage[];
  cursor?: string;
  count: number;
}

export interface IRange {
  start: number;
  end: number;
}

export interface ISearchMessage {
  message: IMessage;
  highlights: IRange[];
  content: string;
}

export interface ISearchUsersAddToGroupRequest {
  groupId?: string;
  groupType?: GroupTypeAddUsersEnum;
  query: string;
  cursor?: string;
  limit: number;
  offset?: string;
}

export interface ISearchUsersAddToGroupResponse {
  cursor?: string;
  users: IUserDisplayData[];
  hasMore: boolean;
}

export enum GroupTypeAddUsersEnum {
  PrivateGroup = 'PRIVATE_GROUP',
  Public = 'PUBLIC',
}

export type ISearchUsersForMentionRequest = {
  groupId: string;
  prefix: string;
  limit: number;
  cursor?: string;
};

export interface ISearchUsersForMentionResponse {
  users: IUserDisplayData[];
  cursor?: string;
}
